import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ConnectedRouter} from 'react-router-redux';

import {unregister as unregisterServiceWorker} from './registerServiceWorker';
import configureStore, {history} from './store/configureStore.js';
import AppRoutes from './routes';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx